import { useNavigate, useSearchParams } from "react-router-dom";
var PRESERVED_PARAMS = ["ln", "preview"];
var useNavigateWithParams = function () {
    var navigate = useNavigate();
    var searchParams = useSearchParams()[0];
    return function (path, options) {
        var params = new URLSearchParams();
        PRESERVED_PARAMS.forEach(function (key) {
            var value = searchParams.get(key);
            if (value)
                params.set(key, value);
        });
        var query = params.toString();
        navigate(query ? "".concat(path, "?").concat(query) : path, options);
    };
};
export { useNavigateWithParams };
